<template>
    <div :class="generalClass">
        <slot name="header" :accordionOpen="isOpen" :accordionToggle="toggle">
            <div
                class="lz-relative lz-flex lz-cursor-pointer lz-items-center lz-justify-between"
                @click="toggle()">
                <slot name="title" :accordionOpen="isOpen">
                    <div class="lz-text-lg lz-font-medium lz-text-current">
                        {{ title }}
                    </div>
                </slot>
                <div>
                    <lz-icon :name="isOpen ? 'minus' : 'plus'" class="w-4 h-4 lz-stroke-current lz-transition-transform lz-duration-150 lz-ease-in-out" />
                </div>
            </div>
        </slot>
        <collapse-transition v-show="isOpen">
            <slot :accordionToggle="toggle" />
        </collapse-transition>
    </div>
</template>

<script setup lang="ts">
import CollapseTransition from '@ivanv/vue-collapse-transition/src/CollapseTransition.vue'
import events from '@/events'
import { onBeforeMount, onBeforeUnmount, ref } from 'vue'
import LzIcon from '@/components/base/LzIcon.vue'

const props = withDefaults(
    defineProps<{ generalClass?: string; open?: boolean; group?: string; title?: string }>(),
    {
        generalClass: '',
        open: false,
    },
)
const emit = defineEmits(['toggle'])
const isOpen = ref(props.open)

onBeforeMount(() => {
    events.$on('accordion-open', onAccordionOpened)
})

onBeforeUnmount(() => {
    events.$off('accordion-open', onAccordionOpened)
})

function onAccordionOpened(group: string) {
    if (props.group && props.group === group) {
        isOpen.value = false
    }
}

function toggle() {
    if (!isOpen.value) {
        if (props.group) {
            events.$emit('accordion-open', props.group!)
        }
    }
    isOpen.value = !isOpen.value
    emit('toggle', isOpen.value)
}
</script>
